import {TargetBlank} from '@wandb/weave/common/util/links';
import {notEmpty} from '@wandb/weave/common/util/obj';
import {JSONNaN} from '@wandb/weave/core';
import * as _ from 'lodash';
import React, {useState} from 'react';
import {Grid, Header, Segment} from 'semantic-ui-react';

import DOC_URLS from '../util/doc_urls';
import * as Requests from '../util/requests';
import {InstrumentedLoader as Loader} from './../components/utility/InstrumentedLoader';
import PanelGraph from './PanelGraph';

interface RunModelInfoProps {
  entityName: string;
  projectName: string;
  runName: string;
  summaryMetrics: any;
}

const RunModelInfo = (props: RunModelInfoProps) => {
  const {entityName, projectName, runName} = props;

  const graphKeys = _.map(props.summaryMetrics, (val, key) =>
    val && (val._type === 'graph' || val._type === 'graph-file') ? key : null
  ).filter(notEmpty);
  if (graphKeys.length === 0) {
    return (
      <div className="run-model-info">
        <>
          <p>No model graphs saved for this run.</p>
          <p>
            To save your model, please refer to the{' '}
            <TargetBlank href={DOC_URLS.save}>documentation</TargetBlank>.
          </p>
        </>
      </div>
    );
  }
  return (
    <div className="run-model-info">
      {graphKeys.map(key => (
        <Grid.Column key={key as string}>
          <div className="unpinned-panel">
            <Header>{key}</Header>
            <Graph
              entityName={entityName}
              projectName={projectName}
              runName={runName}
              graph={props.summaryMetrics[key]}
            />
          </div>
        </Grid.Column>
      ))}
    </div>
  );
};

export default RunModelInfo;

interface GraphProps {
  entityName: string;
  projectName: string;
  runName: string;
  graph: any;
}

const Graph = (props: GraphProps) => {
  const {entityName, projectName, runName} = props;
  const [graph, setGraph] = useState(props.graph);
  const [error, setError] = useState<string | undefined>();
  const isFileType = graph._type === 'graph-file';
  let filePath: string = '';
  if (isFileType) {
    filePath = graph.path;
  }
  const onSuccess = (res: any) => {
    const parsed = JSONNaN.JSONparseUserFile(res);
    if (parsed.error) {
      setError("Couldn't parse json data");
    } else {
      setGraph(parsed.result);
    }
  };
  const loading = Requests.useLoadFile(
    {entityName, projectName, runName},
    filePath,
    {
      skip: !isFileType,
      onSuccess,
    }
  );
  if (isFileType && loading) {
    return <Loader name="run-mode-info-loader" />;
  }
  if (error) {
    return <Segment>{error}</Segment>;
  }
  if (graph == null) {
    throw new Error('Invalid RunModelInfo state: parsed JSON is null');
  }
  return <PanelGraph graph={graph} />;
};
